export const INSURANCE_LIMIT = 150_000;
